import { switchStyles as fastSwitchStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationSwitchStyles = (context, definition) => css `
  ${fastSwitchStyles(context, definition)}
  .checked-indicator {
    transform: scale(1.3);
  }

  .switch {
    border-radius: calc(var(--control-corner-radius) * 3px);
  }

  .checked-indicator {
    border-radius: calc(var(--control-corner-radius) * 2px);
  }
`;
